module.exports = __webpack_public_path__ + "img/students5_new.0040f3a7.png";